import React, { useRef, useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import styles from './CreateNews.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import DatePicker from 'react-datepicker';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../../Constants';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFetchEventCountdownById } from '../../../../Hooks/Events';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import TextInput from '../../../Atoms/Inputs/TextInput';
import { isEmpty } from 'lodash';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../../Molecules/Loader/Loader';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';
import DateInput from '../../../Atoms/Inputs/DateInput';

const CreateEventCountdown = () => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const formikRef = useRef(null);
  const { data, isLoading, refetch } = useFetchEventCountdownById(id);
  const [imageSrc, setImageSrc] = useState('');
  const navigate = useNavigate();
  const customizedToast = useToast();
  const calendarIcon = (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Group 20956'>
        <path
          id='Vector'
          d='M5.43428 0C5.89173 0 6.26256 0.356629 6.26256 0.79655V2.40335C6.99725 2.38964 7.82078 2.38964 8.74737 2.38964H13.1648C14.0914 2.38964 14.9149 2.38964 15.6496 2.40335V0.79655C15.6496 0.356629 16.0204 0 16.4779 0C16.9353 0 17.3062 0.356629 17.3062 0.79655V2.47382C18.8957 2.59623 19.9393 2.89665 20.7059 3.63393C21.4726 4.37121 21.785 5.37475 21.9122 6.90341L21.9999 7.69996H1.01701H0V6.90341C0.12728 5.37475 0.439668 4.37121 1.20631 3.63393C1.97296 2.89665 3.01647 2.59623 4.60601 2.47382V0.79655C4.60601 0.356629 4.97684 0 5.43428 0Z'
          fill='#A9A7A7'
        />
        <path
          id='Vector_2'
          d='M22 14.0001V12.0001C22 11.161 21.9965 9.66526 21.9823 9H0.0110106C-0.00319018 9.66526 0.000406649 11.161 0.000406649 12.0001V14.0001C0.000406649 17.7712 0.000406628 19.6568 1.28911 20.8284C2.57782 22 4.65196 22 8.80026 22H13.2002C17.3485 22 19.4226 22 20.7114 20.8284C22 19.6568 22 17.7712 22 14.0001Z'
          fill='#A9A7A7'
        />
      </g>
    </svg>
  );

  useEffect(() => {
    if (!isEmpty(id) && undefined !== id) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(data)) {
      const eventData = data.data[0];
      formikRef.current.setValues({
        name: eventData.eventNameEN || '',
        nameAr: eventData.eventNameAR || '',
        postedDate: eventData.eventDate ? new Date(eventData.eventDate) : '',
      });
      setImageSrc(
        sanitizeAndValidateUrl(
          `${data?.data[0]?.url}${data?.data[0]?.eventImage}`
        )
      );
    }
  }, [data]);

  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required('Arabic event name is required'),
    postedDate: Yup.date().required('Posted date is required'),
    image:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().notRequired(),
  });

  const mutation = useMutation(
    (formData) =>
      axios.post(API_URL + `/api/News/PostEventCountDown`, formData, {
        headers: securityHeaders,
      }),
    {
      onSuccess: () => {
        customizedToast.open(id ? 'Event Updated' : ' New Added Countdown');
        setTimeout(() => {
          formikRef.current.resetForm();
          navigate(-1);
        }, 2000);
      },
      onError: (error) => {
        toast.error(error?.message);
      },
    }
  );

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append('EventNameAR', values.nameAr);
      if (undefined !== values.image) {
        formData.append('EventImage', values.image);
      }
      formData.append(
        'EventDate',
        moment(values.postedDate).format('YYYY-MM-DD HH:mm:ss')
      );
      const eventId = id ? id : '00000000-0000-0000-0000-000000000000';
      formData.append('EventCountDownId', eventId);
      await mutation.mutateAsync(formData);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          title={id ? 'تعديل العد التنازلي للحدث' : 'إنشاء العد التنازلي للحدث'}
          handleSubmit={triggerFormSubmission}
        />
      </div>
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: data?.data[0]?.eventNameAR || '',
            postedDate: data?.data[0]?.eventDate
              ? new Date(data?.data[0]?.eventDate)
              : '',
            image: null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <div className={styles['newsletter-steps']}>
                <TextInput
                  label='الاسم'
                  placeholder='أدخل الاسم'
                  icon={folderIcon}
                  style={{
                    width: '100%',
                    justifyContent: 'flex-start',
                    marginBottom: '26px',
                  }}
                  containerStyle={{ padding: '0px' }}
                  name='nameAr'
                  value={values.nameAr}
                  errors={errors.nameAr}
                  touched={touched.nameAr}
                  onChange={(name, value) => setFieldValue(name, value)}
                  left
                />
                <DateInput
                  label='تاريخ النشر'
                  placeholder='حدد التاريخ والوقت'
                  showIcon
                  value={values.postedDate}
                  name='postedDate'
                  onChange={setFieldValue}
                  showTimeSelect={true}
                  dateFormat='yyyy-MM-dd HH:mm:ss'
                  timeFormat='HH:mm'
                  timeInputLabel='Time:'
                  errors={errors.postedDate}
                  touched={touched.postedDate}
                />
              </div>

              {errors.image && (
                <div className={styles['error-message']}>
                  <p>{errors.image}</p>
                </div>
              )}
              <div
                className={styles['upload-container']}
                onClick={() => fileInputRef.current.click()}
              >
                <input
                  type='file'
                  accept='image/*'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={(event) =>
                    setFieldValue('image', event.currentTarget.files[0])
                  }
                />
                {values.image ? (
                  <img
                    className={styles['uploaded-image']}
                    src={URL.createObjectURL(values.image)}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : imageSrc ? (
                  <img
                    className={styles['uploaded-image']}
                    src={imageSrc}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        Select Image to Upload
                      </p>
                      <p className={styles['size']}>max size: 100MB</p>
                    </div>
                  </div>
                )}
              </div>
              <button
                type='submit'
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CreateEventCountdown;
